<template>
  <section class="sm-settings-main">
    <components :is="currentTab" />
  </section>
</template>

<script>
export default {
  name: 'settings-main',
  components: {
    'general': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/General.vue'),
    'coupons': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/Coupons.vue'),
    'plans': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/Plans.vue'),
    'payments': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/Payments.vue'),
    'company': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/CompanyInfo.vue'),
    'other': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/Other.vue'),
    'service': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/settings/components/Service.vue'),
  },
  data() {
    return {
      currentTab: null,
      allTabs: [
        'company',
        'general',
        'coupons',
        'plans',
        'payments',
        'other',
        'service'
      ]
    };
  },
  created() {

    this.updateCurrentTab();
  },
  methods: {
    updateCurrentTab() {
      let query = this.$route.query;

      if (query.tab && this.allTabs.includes(query.tab)) {
        this.currentTab = query.tab;
      } else {
        this.currentTab =  this.allTabs[0];
      }
    },
  },
  watch: {
    '$route.query'() {
      this.updateCurrentTab();
    }
  }
}
</script>
